import { brand } from "../config/brands";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getLabels, updateOrderStatus } from "../adapter/api";

const OrderDetails = () => {
  const { id } = useParams(); // Get order ID from URL
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deliveryCharge, setDeliveryCharge]= useState(0)
  const [dollarRate, setDollarRate]= useState(0)
  const [viewButton, setViewButton]= useState(false)

  const getLabel= async () =>{

    try {
      //setLoading(true)
      const response = await getLabels();
      setDeliveryCharge(response.data.data.deliveryCharge)
      setDollarRate(response.data.data.dollarRate)

    } catch (error) {
      
      console.log("error message", error);
    }
  }

  const changeOrderStatus = async () => {
    const response = await updateOrderStatus(id,2);
    if (response.data.status) {
      const response2 = await updateOrderStatus(id,3);
      setViewButton(true)
      if(response2.data.staus){
       
      

      }
  
      
    }
  };

  useEffect(() => {
    getLabel()
    const fetchOrderDetails = async () => {
      try {
        const response = await fetch(`${brand.apiBaseUrl}/order/${id}`);
        if (!response.ok) throw new Error("Order not found");
        const data = await response.json();
        setOrder(data.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [id]);

  if (loading) return <p>Loading order details...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div className="order-details-page max-w-3xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-lg border">
          <img src={brand.logo} alt={`${brand.displayName} logo`} className="w-25 h-10 mb-8 block mx-auto object-contain" />
    <h2 className="text-2xl font-bold text-gray-800 border-b pb-2 mb-4">Order Details</h2>

    <div className="space-y-3">
      <p><strong>Order Number:</strong> {order.orderNumber}</p>
      <p><strong>Amount:</strong> ${(order.totalAmount - (order.deliveryCharge/dollarRate)).toFixed(2)}</p>
      <p><strong>Delivery Charge:</strong> LBP {order.deliveryCharge}</p>
      <p><strong>Total Amount:</strong> ${order.totalAmount}</p>
      <p><strong>Payment Method:</strong> {order.paymentMethod}</p>
      {order.receiverNumber && <p><strong>Receiver Number:</strong> {order.receiverNumber}</p>}
      {order.notes || order.callMe || order.ringTheBell || order.leaveWithDoorMan && <div><p><strong>Notes:</strong></p>
      {order.notes}
      {order.callMe && 'Call when you arrive'}
      {order.ringTheBell && 'Dont ring the bell'}
      {order.leaveWithDoorMan && 'Leave With the Door Man'}
      </div>}
    </div>

    {/* Customer Details */}
    {order.customer && (
      <div className="mt-6 p-4 bg-gray-100 rounded-md">
        <h3 className="text-xl font-semibold text-gray-700">Customer Details</h3>
        <p><strong>Name:</strong> {order.customer.firstName}</p>
        <p><strong>Phone:</strong> {order.customer.phoneNumber}</p>
      </div>
    )}

    {/* Addresses */}
    <div className="mt-6 grid grid-cols-2 gap-4">
      {order.address && order.addressTo && (
        <div className="p-4 bg-gray-100 rounded-md">
          <h3 className="text-lg font-semibold text-gray-700">From Address</h3>
          <p>{order.address.street}, {order.address.city} {order.address.instructions && ','+ order.address.instructions}</p>
          {order.address.google_map_coordinates && (
              <a 
                href={`https://www.google.com/maps?q=${order.address.google_map_coordinates.x},${order.address.google_map_coordinates.z}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                View on Google Maps
              </a>
            )}
        </div>
      )}

{order.address && !order.addressTo && (
        <div className="p-4 bg-gray-100 rounded-md">
          <h3 className="text-lg font-semibold text-gray-700">Address</h3>
          <p>{order.address.street}, {order.address.city} {order.address.instructions && ','+ order.address.instructions}</p>
          {order.address.google_map_coordinates && (
              <a 
                href={`https://www.google.com/maps?q=${order.address.google_map_coordinates.x},${order.address.google_map_coordinates.z}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                View on Google Maps
              </a>
            )}
        </div>
      )}

       {order.addressTo && (
          <div className="p-4 bg-gray-100 rounded-md">
            <h3 className="text-lg font-semibold text-gray-700">To Address</h3>
            <p>{order.addressTo.street}, {order.addressTo.city} {order.addressTo.instructions && ','+ order.addressTo.instructions}</p>
            {order.addressTo.google_map_coordinates.x && order.addressTo.google_map_coordinates.z && (
              <a 
                href={`https://www.google.com/maps?q=${order.addressTo.google_map_coordinates.x},${order.addressTo.google_map_coordinates.z}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                View on Google Maps
              </a>
            )}
          </div>
        )}
    </div>

    {/* Items */}
    {order.items.length > 0 && (
      <div className="mt-6">
        <h3 className="text-xl font-semibold text-gray-700">Items</h3>
        <ul className="mt-2 space-y-2">
          {order.items.map((item, index) => (
            <li key={index} className="p-3 bg-gray-50 rounded-md shadow-sm">
                 <div className="flex items-center">
            {item.image && (
              <img
                src={item.image}
                alt={item.name}
                className="w-12 h-12 object-cover rounded-md mr-4"
              />
            )}
             <div>
            {item.name}
            </div>
          </div>

            </li>
          ))}
        </ul>
      </div>
    )}

    {/* Carts */}
    {order.carts.length > 0 && (
      <div className="mt-6">
        <h3 className="text-xl font-semibold text-gray-700">Cart Items</h3>
        <ul className="mt-2 space-y-2">
          {order.carts.map((cart, index) => (
            <li key={index} className="p-3 bg-gray-50 rounded-md shadow-sm">
                       <div className="flex justify-between items-center">
            {cart.product.image && (
              <img
                src={cart.product.image}
                alt={cart.product.name}
                className="w-12 h-12 object-cover rounded-md mr-4"
              />
            )}
            <div className="w-1/3">
              <strong>{cart.product.name}</strong> - {cart.quantity} x ${cart.price}
            </div>
            <div className="ml-7 w-1/3">
            {cart.notes}
            </div>
          </div>

            </li>
          ))}
        </ul>
      </div>
    )}
    
{!viewButton ? <button
  className="mt-8 w-full bg-yellow hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300"
  onClick={() => {

    changeOrderStatus()
  }}
>
  Confirm & Start Preparing
</button>:<p className="text-lg font-semibold text-yellow text-center pt-5">Order Confirmed!</p>}
  </div>
  );
};

export default OrderDetails;
